import { PUBLISHER_CONTRACT_STATUS } from "@panel/shared/contract/misc/constants";
import { normalizeSignatures, publisherContractStatusOf } from "@panel/shared/contract/misc/helpers";

/**
 * The publisher's own contract with the account's brand, as the one row the
 * table renders — or no rows while ops has not sent it (including while it is
 * still queued), which the API answers with `contract_id: null`.
 * @param raw
 */
export const normalizeContracts = (raw) => {
    if (!raw?.contract_id) return [];

    return [
{
        id        : raw.contract_id,
        version   : raw.version ?? null,
        status    : publisherContractStatusOf(raw.status),
        signatures: normalizeSignatures(raw.signatures),
        sentAt    : raw.sent_at || null,
        signedAt  : raw.completed_at || null,
        exists    : true
    }
];
};

/**
 * How many contracts are waiting on this publisher's signature.
 * @param contracts
 */
export const countAwaiting = (contracts = []) => contracts
    .filter((contract) => contract.status === PUBLISHER_CONTRACT_STATUS.AWAITING_PUBLISHER).length;

/**
 * The brand signs first: until it has, the server rejects the publisher's
 * signature with a 409, so it is locked here too.
 * @param contract
 */
export const isWaitingOnBrand = (contract) => [
    PUBLISHER_CONTRACT_STATUS.AWAITING_BRAND,
    PUBLISHER_CONTRACT_STATUS.BRAND_SIGN_QUEUED
].includes(contract?.status);
